module.exports = __webpack_public_path__ + "static/media/faq_image.14ae8e5b.svg";